<h2 mat-dialog-title>{{ 'selectAppModeConfirmDialog.visolModeLabel' | translate }}</h2>

<div class="container" fxLayout="column" fxLayoutAlign="center center">
  <p class="messages first">
    {{ 'selectAppModeConfirmDialog.message3' | translate}}
  </p>
</div>

<div class="container" fxLayout="row" fxLayoutAlign="center center" position="fixed">
  <mat-dialog-actions>
    <button mat-raised-button color="primary" [mat-dialog-close]="false">{{ 'selectAppModeConfirmDialog.goBack' | translate}}</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true">{{ 'selectAppModeConfirmDialog.next' | translate}}</button>
  </mat-dialog-actions>
</div>
